export function RemainingClock({ color }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3.75V6"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.95 7.125L6 6"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.36548 4.67285H1.49048V2.79785"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.08423 8.91563C3.66099 9.49286 4.39599 9.88606 5.19625 10.0455C5.99651 10.2049 6.82608 10.1234 7.58003 9.81133C8.33397 9.49921 8.9784 8.9705 9.43181 8.29208C9.88522 7.61365 10.1272 6.81599 10.1272 6C10.1272 5.18401 9.88522 4.38635 9.43181 3.70792C8.9784 3.0295 8.33397 2.50079 7.58003 2.18868C6.82608 1.87656 5.99651 1.79507 5.19625 1.95451C4.39599 2.11395 3.66099 2.50715 3.08423 3.08438L1.49048 4.67344"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
